import Layout from "@/components/common/Layout";
import BackgroundImage from "@/components/site-builder/BaseModule/ModuleUI/BackgroundImage";
import BackgroundOverlay from "@/components/site-builder/BaseModule/ModuleUI/BackgroundOverlay";
import CallToActionGroup from "@/components/site-builder/CallToActionGroup";
import TextField from "@/components/site-builder/TextField";
import type { HeroCarouselBlock, HeroCarouselModuleType } from "../types";
import s from "./HeroCarouselVariant1.module.scss";

export interface HeroCarouselVariant1Props {
  module: HeroCarouselModuleType;
  block: HeroCarouselBlock;
}

export default function HeroCarouselVariant1(props: HeroCarouselVariant1Props) {
  const {
    module: {
      style: {
        background: { image: imageSettings, overlay: overlaySettings },
      },
      body: { buttonsAlignment },
    },
    block: { preTitle, title, subTitle, intro, buttons, image },
  } = props;

  return (
    <div className={s.wrapper}>
      <BackgroundImage settings={{ ...imageSettings, enabled: true, image }} />
      {overlaySettings.enabled && image?.source && (
        <BackgroundOverlay settings={overlaySettings} />
      )}
      <Layout containerOnly>
        <div className={s.body}>
          <TextField field={preTitle} type="pre-title" />
          <TextField field={title} type="title" />
          <TextField field={subTitle} type="sub-title" />
          <TextField field={intro} type="intro" />
          {buttons.length > 0 && (
            <CallToActionGroup buttons={buttons} position={buttonsAlignment} />
          )}
        </div>
      </Layout>
    </div>
  );
}
